import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    // This the only mandatory field that you need to supply
    clientId: "95851edf-14aa-4d7a-8436-f4580c1235fa",
    // Replace the placeholder with your tenant subdomain
    authority: "https://login.microsoftonline.com/common",
    // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
    redirectUri: "/",
    // Indicates the page to navigate after logout
    postLogoutRedirectUri: "/",
    // If "true" will navigate back to the original request location before processing the auth code response
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // Config cache location. "sessionStorage" is more secure
    // but "localStorage" gives you sso between tabs
    cacheLocation: "sessionStorage",
    // Set this to "true" if you are having issues on IE11 or Edge
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      piiLoggingEnabled: false,
    },
    // windowHashTimeout: 60000,
    // iframeHashTimeout: 6000,
    // loadFrameTimeout: 0,
    // asyncPopups: false,
  },
};

/**
 * Scopes you add here will be prompted for user consent during login.
 * By default, MSAL.js will add OIDC scopes (openId, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 *
 */

export const loginRequest = {
  scopes: ["user.read"],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
